import _ from "lodash"
import React from "react"
import { BadgeCell, DefaultCell } from "./components/cells"
import { BASE_URL } from "../../../consts/app.consts"
import axios from "axios"

const AssesmentConfig = {
    searchApi: 'xceed.api.report.assesment.generate_assesment_report',
    excelFileName: 'attendance-report',
    title: 'Assesment Report',
    extraActionsAsMenu: true,
    sections: [{
        selectionTitle: "Filters",
        grid: { base: 1, md: 2, lg: 4, xl: 4 },
        filters: [
            // {
            //     label: 'Student',
            //     key: 'student',
            //     type: 'form-select',
            //     optionMethod: 'xceed.api.report.assesment.get_students',
            // },
            {
                label: 'Program',
                key: 'program',
                type: 'form-select',
                optionMethod: 'xceed.api.report.assesment.get_programs_by_student',
                methodBody: {
                    "student": "student"
                }
            },
            {
                label: 'Program Module',
                key: 'program_module',
                type: 'form-select',
                optionMethod: 'xceed.api.report.assesment.get_program_modules_by_student_and_program',
                methodBody: {
                    "student": "student",
                    "program": "program"
                }
            },
        ]
    }],
    // extraActionsAsMenu: true,

    tableConfig: {
        column: [
            {
                header: "Student Name",
                accessor: "student_name",
                customRenderer: (value: any, item: any) => (
                    React.createElement(DefaultCell, { navigateTo: `/app/student/${_.get(item, 'student_id')}`, value: value })
                ),
                width: 200
            },
            {
                header: "NIC",
                accessor: "nic",
                width: 100
            },
            {
                header: "Original Program",
                accessor: "program_title",
                // customRenderer: (value: any, item: any) => (
                //     React.createElement(DefaultCell, { navigateTo: `/app/program/${_.get(item, 'program_id')}`, value: value })
                // ),
                width: 200
            },
            {
                header: "Original Program Module",
                accessor: "title",
                // customRenderer: (value: any, item: any) => (
                //     React.createElement(DefaultCell, { navigateTo: `/app/program-module/${_.get(item, 'program_module_id')}`, value: value })
                // ),
                width: 200
            },
            {
                header: "extension_program",
                accessor: "extension_program",
                width: 200
            },
            {
                header: "extension program module",
                accessor: "extension_program_module",
                width: 200
            },
            {
                header: "Marks",
                accessor: "mark",
                width: 50
            },
            {
                header: "Doc. Status",
                accessor: "status",
                width: 50,
                customRenderer: (value: any, item: any) => (
                    React.createElement(BadgeCell, { value: value, config: statusBadgeConfig })
                ),
            }
        ]
    },
    actions: [
        {
            text: "Generate Course Marksheet",
            onClick: async (filter: any, data: any, setLoading: any) => {
                if (filter.program) {
                    setLoading(true)
                    try {
                        let response = await axios.post(`${BASE_URL}/method/xceed.api.export_excel.assesment.export_course_mark_sheet`, { filter }, {
                            withCredentials: true,
                            responseType: "blob"
                        })
                        if (response) {
                            setLoading(false)
                            return {
                                type: "message",
                                body: {
                                    "message": "Report execution may take some time. Once the report is generated, the system will send it to your email address."
                                }
                            }
                        }
                        setLoading(false)

                    } catch (error: any) {
                        setLoading(false)
                        const newError: any = new Error('Unable to Generate Excel file');
                        newError.title = 'Error';
                        newError.status = 'error';
                        throw newError
                    }
                }
                else {
                    const error: any = new Error('Please select a program');
                    error.title = 'Warning';
                    error.status = 'warning';
                    throw error
                }
            },
            buttonVariant: "solid",
            buttonColorScheme: "teal"
        },
        {
            text: "Generate Module Wise Mark Sheet",
            onClick: async (filter: any, data: any, setLoading: any) => {
                if (filter.program) {
                    setLoading(true)
                    try {
                        let response = await axios.post(`${BASE_URL}/method/xceed.api.export_excel.assesment.export_module_wise_mark_sheet`, { filter }, {
                            withCredentials: true,
                            responseType: "blob"
                        })
                        if (response) {
                            console.log(response)
                            const href = URL.createObjectURL(response.data);

                            const link = document.createElement('a');
                            link.href = href;
                            link.setAttribute('download', `module-wise-mark-sheet.xlsx`);
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            URL.revokeObjectURL(href);
                        }
                        setLoading(false)

                    } catch (error: any) {
                        setLoading(false)
                        const newError: any = new Error('Unable to Generate Excel file');
                        newError.title = 'Error';
                        newError.status = 'error';
                        throw newError
                    }
                }
                else {
                    const error: any = new Error('Please select a program');
                    error.title = 'Warning';
                    error.status = 'warning';
                    throw error
                }
            },
            buttonVariant: "solid",
            buttonColorScheme: "teal"
        },
    ]
}

export default AssesmentConfig

const statusBadgeConfig = {
    Confirmed: "bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded",
    Draft: "bg-red-100 text-red-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded",
};
